export class CreditNotePromotionCustomerPageItem {
    customerReferenceID: string;
    tcsMemberID: string;
    firstName: string;
    lastName: string;
    lastRegisteredLicensePlate: string;
    emailAddress: string;
    creditNoteActivationDate: string;
    creditNoteAmountRemaining: number;
  }